/*
  默认证书名称
  该证书有证书编号
  新增证书前需要先配置该证书名称
*/
export const DEFAULT_CERTIFICATE_NAME = '时尚产业联盟（长三角）'
export const YSWL_CERTIFICATE_NAME = '藝尚网来'


/*
  来源名称 - 从衣加加认证企业中同步
*/
export const YJJ_SOURCE_NAME = '从衣加加认证企业中同步'


/*
  企业类型
*/
export const COMPANY_TYPE_NAME = '企业'




// WEBPACK FOOTER //
// ./src/pages/certificate/util/constant.js